export const DatagridHeaderStyle = {
  backgroundColor: 'slategray',
  color: 'white',
  fontWeight: 'bold',
}